export { EditProtocol as default } from "./edit-protocol";
